import React from 'react';
import { useMarketingEmailCampaignEditor } from '../hooks/use-marketing-email-campaign-editor.js';
import MarketingEmailCampaignEditorPageView from './marketing-email-campaign-editor-page-view.jsx';

function MarketingEmailCampaignEditorPageContainer({ mode = 'edit' }) {
  const state = useMarketingEmailCampaignEditor(mode);
  return <MarketingEmailCampaignEditorPageView mode={mode} {...state} />;
}

export default MarketingEmailCampaignEditorPageContainer;
